import { Middleware } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";

const logMiddleware = createLogger({
  duration: true,
  timestamp: true,
  collapsed: true,
  colors: {
    title: () => "#139BFE",
    prevState: () => "#1C5FAF",
    action: () => "#149945",
    nextState: () => "#A47104",
    error: () => "#ff0005",
  },
}) as Middleware;

export { logMiddleware };
